 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","11":"stencil-polyfills-css-shim","12":"stencil-polyfills-dom"}[chunkId]||chunkId) + "-es2015." + {"0":"ffb942727ab596750439","2":"ffc15c1d62459aa6b023","3":"006af3310b6596ec8adf","4":"bd10ffa1c68ca20818c6","5":"33255a9cb658a3024c3d","6":"2cf865032ceec8267a8b","7":"e7ff1d5cc3e7827bb19a","11":"ee7367769c3999c8fc9a","12":"d0e68b74bf3941032d7d","14":"b1c9b983de3760407509","15":"4ce599a0bd5cce1a1c6c","16":"6f5341fcd66ebdb9ce21","17":"2a0b58a90f0461e5f106","18":"c27c4665b44553784d5e","19":"98c1bbbbb8fdb0c12cae","20":"fdceb04df94062bffdaf","21":"ef68f3bfbcfd0554b6c7","22":"f2c1ebad5e8d734f0ec7","23":"40a27191198ed974e02f","24":"26e09a21d198c11a4adf","25":"d95b8e885edaeb97fe6a","26":"18eb2ca5e18261cfd35f","27":"deecfb87c8628978dd49","28":"b011cc32c4218cd619ea","29":"ac21670d017749203e36","30":"fce0474d0d162662c831","31":"e359b92d8c40960401f9","32":"844827e3b491d94ef094","33":"487d7267b45c3b0bb625","34":"a3f3c8bc2cff70a152cf","35":"b98bab55c9084a677a22","36":"a4529bf41c0b0c3d605d","37":"0b871461732744727a69","38":"40fd2213d37b82dcc7e3","39":"c3c9da5f1af39dcad9c1","40":"3b599d3403f3f34d66a6","41":"a2988bf4161ce04e2996","42":"5c7a683fabe016b97fec","43":"cffcb065771b550e21c7","44":"2b0c5fd8bb6e1839d030","45":"3649671d51a0938968d9","46":"51ef1b4dc944127ede33","47":"d31bc7b62bde8366ab7e","48":"42000d3d41bd8c0464b4","49":"11870327c107eec0b4cf","50":"8a2a41344741e94057e5","51":"51cd7189617f6de15b16","52":"d8dafaeb53e5f620bfd3","53":"096aff25f6c1c3e16306","54":"4a3b26594d910d832e19","55":"3a3c3f6afa74536ad69a","56":"abdb0487d2167b436733","57":"bd6dfbf72253c8454595","58":"25b6d123d4c8bacd8ab2","59":"826845b460e9e65f84d5","60":"d201389fffbd729d371d","61":"494a379e39f738b79899","62":"d07fe674081584791135","63":"8867fdfcf2ca6a68b918","64":"03a3c1c9bc4607606c0a","65":"bb5125b7c1ad96790cc6","66":"4e187f48dbc8a71b2357","67":"9eef1370654d31f513c6","68":"682453c270f4bebdb6da","69":"a564bbe5561c9d50cf27","70":"ade69c2d7d93af46d4d2","71":"7d3042642257b56a3442","72":"824ee1736192b610b7f3","73":"ebf34699753870fadab9","74":"2dc6e5ff35e29cd8e3b4","75":"1fc2b9894f9c8770d93c","76":"4648f2052a3cd61a1233","77":"82a16dd71864029668d3","78":"d9d9810ec2fd5f3ed6d9","79":"e122588a20e1c4e72560","80":"075102a5f5d6bedf1ca1","81":"58d244f9192f4f9e19b3","82":"2543799846d899fdee72","83":"5ca0d96873a6ed07bc1d","84":"ce3bd1f6bfca515f9a34","85":"d5c0f2a54ac90acd7490","86":"e8d94a7a8e38a9b555f3","87":"38a7604d5c4d12bbc5e2","88":"8adb6184c344c416254f","89":"833a331fea2899bf28c8","90":"3c583436accaad004c56","91":"790fa934881924b68d19","92":"5590252214a47dea9fad","93":"85c6184bba2bf81929dc","94":"9123ff5cc7d50d41cbfa","95":"d7cc3ab24f04a6538658","96":"e41de12acde3b3a21315"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
